import { useIxfAccountingV1AccountQueryServiceAccountGet } from '@interxfi/api-client/generated/hooks';
import { Skeleton } from '@interxfi/design-system/components/loading/skeleton';

interface AccountingCoaAccountBreadcrumbProps {
  accountId: string;
}

export function AccountingCoaAccountBreadcrumb({ accountId }: AccountingCoaAccountBreadcrumbProps) {
  const { data, error, isPending } = useIxfAccountingV1AccountQueryServiceAccountGet({ accountId });
  const showPending = Boolean(isPending || error);
  if (showPending) {
    return <Skeleton charCount={8} />;
  }

  return data?.account?.data?.spec?.label || 'Account';
}
